"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.6666 10.6666H22.6666V5.33325H3.99992C2.53325 5.33325 1.33325 6.53325 1.33325 7.99992V22.6666H3.99992C3.99992 24.8799 5.78658 26.6666 7.99992 26.6666C10.2133 26.6666 11.9999 24.8799 11.9999 22.6666H19.9999C19.9999 24.8799 21.7866 26.6666 23.9999 26.6666C26.2133 26.6666 27.9999 24.8799 27.9999 22.6666H30.6666V15.9999L26.6666 10.6666ZM25.9999 12.6666L28.6133 15.9999H22.6666V12.6666H25.9999ZM6.66658 22.6666C6.66658 23.3999 7.26658 23.9999 7.99992 23.9999C8.73325 23.9999 9.33325 23.3999 9.33325 22.6666C9.33325 21.9333 8.73325 21.3333 7.99992 21.3333C7.26658 21.3333 6.66658 21.9333 6.66658 22.6666ZM10.9599 19.9999C10.2266 19.1866 9.18659 18.6666 7.99992 18.6666C6.81325 18.6666 5.77325 19.1866 5.03992 19.9999H3.99992V7.99992H19.9999V19.9999H10.9599ZM22.6666 22.6666C22.6666 23.3999 23.2666 23.9999 23.9999 23.9999C24.7333 23.9999 25.3333 23.3999 25.3333 22.6666C25.3333 21.9333 24.7333 21.3333 23.9999 21.3333C23.2666 21.3333 22.6666 21.9333 22.6666 22.6666Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "24",
  cy: "24",
  r: "8",
  fill: "#5EBE09"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFF",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.7002 19.9429L29.1073 21.35L22.4002 28.0571L18.8931 24.55L20.3002 23.1429L22.4002 25.2429L27.7002 19.9429Z"
})), 'DeliverySuccess', {
  viewBox: '0 0 16 16'
});

exports.default = _default;